import {
  BadgeDollarSign,
  WalletCards,
  HandCoins,
  Receipt,
} from "lucide-react";

export const cards = [
  {
    cardBgClassName: "bg-blue-50",
    icon: HandCoins,
    iconBgClassName: "bg-primary",
    title: "2026",
    titleSuffix: "Budget",
    amtKey: "currentYearBudget",
    subTitle: "Total Budget",
    footerText: "Approved On:",
    footerTextKey: "currentYearBudgetApprovalDate",
    footerTextClassName: "text-primary border-blue-100",
  },
  {
    cardBgClassName: "bg-green-50",
    icon: Receipt,
    iconBgClassName: "bg-green-600",
    title: "Actual Receivables",
    amtKey: "actualRecievables",
    subTitle: "100% of Budget",
    footerText: "Outstanding Amount",
    footerTextClassName: "text-green-600 border-green-100",
  },
  {
    cardBgClassName: "bg-amber-50",
    icon: WalletCards,
    iconBgClassName: "bg-amber-600",
    title: "Actual",
    titleSuffix: "Expense",
    amtKey: "actualExpense",
    subTitle: "Total Expense",
    footerText: "Spent Till Date",
    footerTextClassName: "text-amber-600 border-amber-100",
  },
  {
    cardBgClassName: "bg-violet-50",
    icon: BadgeDollarSign,
    iconBgClassName: "bg-violet-600",
    title: "Actual",
    titleSuffix: "Income",
    amtKey: "budgetIncome",
    subTitle: "Total Income",
    footerText: "Income Till Date",
    footerTextClassName: "text-violet-600 border-violet-100",
  }
]
